'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><rect width={22} height={22} x={1} y={1} stroke="currentColor" strokeWidth={2} rx={11} /><path stroke="currentColor" strokeWidth={2} d="M16 10.5c0 1.178-.041 2.42-.5 3.5-.724 1.703-2.148 2-3.5 2s-2.776-.297-3.5-2c-.459-1.08-.5-2.322-.5-3.5C8 7.462 9.79 6 12 6s4 1.462 4 4.5Z" /><path stroke="currentColor" strokeWidth={2} d="m8.806 14.597-3.44 1.72a3 3 0 0 0-1.617 2.19L3.667 19m11.527-4.403 3.44 1.72a3 3 0 0 1 1.617 2.19l.082.493" /></svg>;
const IconCircleUser = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconCircleUser;